export enum InsuranceReportDropdown {
  TIPMVBCS = "TIPMVBCS",
  STSCERT = "STSCERT",
  STSSIN = "STSSIN",
}
